/**
 * Renders the popover body for RmaListFilterControl based on filterControlDataProps.type.
 * Switches between date-range, options, and grouped-options content.
 */
import React from "react";
import RmaListFilterDateRangeContent from "./components/date-range/rma-list-filter-date-range-content";
import RmaListFilterGroupedOptionsContent from "./components/grouped-options/rma-list-filter-grouped-options-content";
import RmaListFilterOptionsContent from "./components/options/rma-list-filter-options-content";
import {
    IRmaListFilterRadioOption,
    RmaListFilterOptionId,
} from "./components/radio-option/rma-list-filter-radio-option";

export enum RMA_LIST_FILTER_CONTROL_DATA_TYPE {
    DATE_RANGE = "DATE_RANGE",
    OPTIONS = "OPTIONS",
    GROUPED_OPTIONS = "GROUPED_OPTIONS",
}

export type { RmaListFilterOptionId };

export type IRmaListFilterControlOption = IRmaListFilterRadioOption;

export interface IRmaListFilterControlOptionGroup {
    title: string;
    options: IRmaListFilterControlOption[];
}

export interface IRmaListFilterControlDateRangeDataProps {
    type: RMA_LIST_FILTER_CONTROL_DATA_TYPE.DATE_RANGE;
    value: string;
    timeZone: string;
    getInputValues?: (timeZone: string) => { from: string; to: string };
    onChange: (isoRange: string) => void;
}

export interface IRmaListFilterControlOptionsDataProps {
    type: RMA_LIST_FILTER_CONTROL_DATA_TYPE.OPTIONS;
    value: RmaListFilterOptionId | null;
    options: IRmaListFilterControlOption[];
    onChange: (id: RmaListFilterOptionId) => void;
}

export interface IRmaListFilterControlGroupedOptionsDataProps {
    type: RMA_LIST_FILTER_CONTROL_DATA_TYPE.GROUPED_OPTIONS;
    value: RmaListFilterOptionId | null;
    groups: IRmaListFilterControlOptionGroup[];
    onChange: (id: RmaListFilterOptionId) => void;
}

export type RmaListFilterControlDataProps =
    | IRmaListFilterControlDateRangeDataProps
    | IRmaListFilterControlOptionsDataProps
    | IRmaListFilterControlGroupedOptionsDataProps;

interface IProps {
    filterControlDataProps: RmaListFilterControlDataProps;
    isOpen: boolean;
}

const RmaListFilterControlContent: React.FC<IProps> = ({
    filterControlDataProps,
    isOpen,
}) => {
    switch (filterControlDataProps.type) {
        case RMA_LIST_FILTER_CONTROL_DATA_TYPE.DATE_RANGE:
            return (
                <RmaListFilterDateRangeContent
                    value={filterControlDataProps.value}
                    timeZone={filterControlDataProps.timeZone}
                    getInputValues={filterControlDataProps.getInputValues}
                    onChange={filterControlDataProps.onChange}
                    isOpen={isOpen}
                />
            );
        case RMA_LIST_FILTER_CONTROL_DATA_TYPE.OPTIONS:
            return (
                <RmaListFilterOptionsContent
                    value={filterControlDataProps.value}
                    options={filterControlDataProps.options}
                    onChange={filterControlDataProps.onChange}
                />
            );
        case RMA_LIST_FILTER_CONTROL_DATA_TYPE.GROUPED_OPTIONS:
            return (
                <RmaListFilterGroupedOptionsContent
                    value={filterControlDataProps.value}
                    groups={filterControlDataProps.groups}
                    onChange={filterControlDataProps.onChange}
                />
            );
        default:
            return null;
    }
};

export default RmaListFilterControlContent;
